<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import ContactUs from '$lib/PageSections/Forms/ContactUs/ContactUs.svelte';

	import janeInstall from './images/Jane-install.svg';
</script>

<Section backgroundColor="grey-light" class="[&_p]:text-left">
	<div class="mb-4 flex h-full flex-col gap-8 lg:flex-row">
		<div class="flex flex-col justify-around gap-4">
			<Image src={janeInstall} class="max-w-72" />
		</div>
		<div class="flex flex-col place-content-center [&_p]:mb-4">
			<p>
				Your order will enter our production queue once we have received final
				payment. We are currently anticipating a 3-5 week production time for
				Residential orders and 4-6 weeks for Commercial orders.
			</p>
			<p>
				We offer <a href="/warranties/expedited-production"
					>expedited production</a
				> for Residential orders - ask your Fit Specialist for more information.
			</p>
			<p>
				Once shipped, most customers receive their inserts in 1-2 weeks, however
				shipping timelines vary based on location and carrier routes.
			</p>
			<p>
				Orders containing <a href="/resources/blog/insulate-specialty-windows"
					>Specialty Shapes</a
				> and larger orders may exceed the standard lead time.
			</p>
			<p>Please reach out to us if you have any questions or concerns.</p>
		</div>
	</div>
	<h2>Contact Us</h2>
	<ContactUs class="max-w-xl rounded-lg bg-indow-white p-6 shadow-lg"
	></ContactUs>
</Section>
